import * as DateFns from 'date-fns';

import type { Order } from '@order/graphql';
import { FlattenedOrderStatuses } from '@order/graphql';
import { ignoreTimezone } from '@order/utils';

import { getOrderTime } from './getOrderTime';

/**
 * Orders are considered past if their completed time is 1hrs in the past.
 */
export const checkIfPastOrder = ({
  order,
  flattenedOrderStatus = FlattenedOrderStatuses.Failed,
}: IsOrderPastProps) => {
  const canBePast = flattenedOrderStatus === 'completed';

  const orderTime = order ? getOrderTime(order) ?? '' : '';
  const orderTimeDate = orderTime ? ignoreTimezone(orderTime) : undefined;

  const oneHourAgo = DateFns.subHours(new Date(), 1);
  const isPast = orderTimeDate
    ? DateFns.isBefore(orderTimeDate, oneHourAgo)
    : false;

  return canBePast && isPast;
};

type IsOrderPastProps = {
  readonly order?: Partial<Order>;
  readonly flattenedOrderStatus?: FlattenedOrderStatuses;
};
